<template>
	<div class="service-slug-container flex-centerize mr-3">
		<SIcon v-if="serviceSlug" :name="serviceSlug" :width="20" />
	</div>
</template>

<script>
export default {
	name: 'ConnectionServiceCard',
	props: { serviceSlug: { type: String } },
};
</script>
<style lang="scss" scoped>
.service-slug-container {
	min-width: 45px;
	max-width: 45px;
	min-height: 45px;
	max-height: 45px;
	border-radius: 10px;
	background: var(--bg-color);
	border: 1px solid var(--border-color);
	box-shadow: 0px 1px 2px var(--border-color);
}
</style>
